var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.431.285H8.058A7.895 7.895 0 0 0 .163 8.18v26.318a7.895 7.895 0 0 0 7.895 7.895h47.373a7.895 7.895 0 0 0 7.895-7.895V8.18A7.895 7.895 0 0 0 55.431.285z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.358 31.89c5.607 0 10.155-4.73 10.155-10.553 0-5.825-4.548-10.55-10.155-10.55-5.611 0-10.16 4.725-10.16 10.55 0 5.825 4.549 10.554 10.16 10.554z",
    fill: "#E2001A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.135 31.89c5.606 0 10.154-4.73 10.154-10.553 0-5.825-4.547-10.55-10.154-10.55-5.612 0-10.155 4.725-10.155 10.55 0 5.825 4.543 10.554 10.155 10.554z",
    fill: "#F6A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.74 28.577a10.77 10.77 0 0 1-2.76-7.24c0-2.77 1.031-5.293 2.708-7.175l.214.115a10.76 10.76 0 0 1 2.61 7.06c0 2.727-.998 5.208-2.629 7.085l-.143.155z",
    fill: "#EB690A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.43 1.162H8.058A7.018 7.018 0 0 0 1.04 8.18v26.318a7.018 7.018 0 0 0 7.018 7.018H55.43a7.018 7.018 0 0 0 7.018-7.018V8.18a7.018 7.018 0 0 0-7.018-7.018z",
    stroke: "url(#c)",
    strokeWidth: 1.755
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.66636 25.8986 -39.17583 -4.0333 44.736 15.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ECC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#EDB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E99999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E66F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E74141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v43H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -50,
    y: -50,
    width: 164,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_428_314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_428_314",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.7780fc545ec1e4a9245bb52062c56a8a.svg";
export { ForwardRef as ReactComponent };